import { CampaignCityReport } from "../../constants/action-constants/CampaignCityReportActionConstants";

export const getCityOverview = (campaignId, cityId) => ({
  type: CampaignCityReport.GET_CITY_OVERVIEW,
  payload: { campaignId, cityId },
});

export const approxOts = (
  campaignId,
  cityId,
  previouscanBeApproximatedCount,
  previousCannotBeApproximatedCount
) => ({
  type: CampaignCityReport.APPROX_OTS_FOR_CITY,
  payload: {
    campaignId,
    cityId,
    previouscanBeApproximatedCount,
    previousCannotBeApproximatedCount,
  },
});

export const downloadCityPdfReport = (
  campaignId,
  cityId,
  mapCenter,
  mapZoom,
  isSentViaEmail,
  emailIds
) => ({
  type: CampaignCityReport.DOWNLOAD_CITY_PDF_REPORT,
  payload: {
    campaignId,
    cityId,
    mapCenter,
    mapZoom,
    isSentViaEmail,
    emailIds,
  },
});

export const resetCityPdfReport = () => ({
  type: CampaignCityReport.RESET_CITY_PDF_REPORT,
});

export const downloadCityMediasPdfReportsZip = (
  campaignId,
  cityId,
  radius,
  isSentViaEmail,
  emailIds
) => ({
  type: CampaignCityReport.DOWNLOAD_CITY_MEDIAS_PDF_REPORTS_ZIP,
  payload: { campaignId, cityId, radius, isSentViaEmail, emailIds },
});

export const resetCityMediasPdfReportsZip = () => ({
  type: CampaignCityReport.RESET_CITY_MEDIAS_PDF_REPORTS_ZIP,
});

export const downloadCityMediasSinglePdfReport = (
  campaignId,
  cityId,
  radius,
  isSentViaEmail,
  emailIds
) => ({
  type: CampaignCityReport.DOWNLOAD_CITY_MEDIAS_SINGLE_PDF_REPORT,
  payload: { campaignId, cityId, radius, isSentViaEmail, emailIds },
});

export const resetCityMediasSinglePdfReport = () => ({
  type: CampaignCityReport.RESET_CITY_MEDIAS_SINGLE_PDF_REPORT,
});

// Form Actions for Downloading Campaign City Report
export const openDownloadCampaignCityReportForm = () => ({
  type: CampaignCityReport.OPEN_DOWNLOAD_CAMPAIGN_CITY_REPORT_MODAL,
});

export const closeDownloadCampaignCityReportForm = () => ({
  type: CampaignCityReport.CLOSE_DOWNLOAD_CAMPAIGN_CITY_REPORT_MODAL,
});
